import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../service";
import {
    deletedRestoreTeaching,
    deletedTeachingTypes,
    setTeachingRestoreData,
    setTeachingTypes,
    updateTeachingTypes,
} from "./teachingTypeSlice";
import { ITeachingTypeCreate, ITeachingTypePayload } from "../types";
import { IErrorResponse, IRootState } from "../../../../types";

const GetTeachingTypes = createAsyncThunk("get/teaching/types", async (_, { dispatch, rejectWithValue, getState }) => {
    try {
        const response = await request.get("/teaching-types");
        const lang = getState() as IRootState;
        const defaultLanguage = lang.languages.defaultLanguage;
        dispatch(setTeachingTypes({ data: response.data, defaultLanguage }));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const SetTeachingTypes = createAsyncThunk(
    "set/teaching/types",
    async (data: ITeachingTypeCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/teaching-types", data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteTeachingTypes = createAsyncThunk(
    "delete/teaching/types",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.delete(`/teaching-types/${id}`);

            dispatch(deletedTeachingTypes(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditTeachingTypes = createAsyncThunk(
    "edit/teaching/types",
    async (data: ITeachingTypePayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/teaching-types/${data.id}`, data);
            dispatch(updateTeachingTypes(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteATeachingTypes = createAsyncThunk("get/delete/department", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get(`/teaching-types/deleted-items`);

        dispatch(setTeachingRestoreData(response.data));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const RestoreDeleteTeachingTypes = createAsyncThunk(
    "restore/delete/teaching/types",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/teaching-types/restore/${id}`);

            dispatch(deletedRestoreTeaching(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export {
    GetTeachingTypes,
    SetTeachingTypes,
    DeleteTeachingTypes,
    EditTeachingTypes,
    GetDeleteATeachingTypes,
    RestoreDeleteTeachingTypes,
};
